module.exports = __webpack_public_path__ + "img/home01.899cd826.png";